export const PLATFORM_PAYMENT_ID = '625595';
